import * as React from "react";
import styles from "./UserMenu.module.scss";
import { logout } from "../AuthProvider/AuthProvider";
import userBlue from "../../assets/userBlue.svg";
import chevronDown from "../../assets/chevron-down.svg";
import exitIcon from "../../assets/exit-blue.svg";
import { useTranslation } from "react-i18next";

export type UserMenuProps = {
  userName: string;
  userTitle?: string;
  setLanguageSelectionOpen: (value: boolean) => void;
  setMobileUserMenuOpen: (value: boolean) => void;
  setFeedbackOpen: (value: boolean) => void;
};

const UserMenu: React.FC<UserMenuProps> = (props: UserMenuProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.OnlyInDesktop}>
        <div className={styles.UserMenu}>
          <ul>
            <li>
              <a href="#">
                <div className={styles.UserMenuToggle}>
                  <img className={styles.UserMenuIcon} alt="Menu" src={userBlue} />
                  <div className={styles.UserInfo}>
                    <span className={styles.UserTitle}>{props.userTitle}</span>
                    <span>{props.userName}</span>
                  </div>
                  <img alt="Menu" className={styles.DropdownToggle} src={chevronDown} />
                </div>
              </a>
              <ul>
                <li>
                  <a href="#" onClick={() => props.setLanguageSelectionOpen(true)}>
                    {t("language")}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      props.setFeedbackOpen(true);
                      props.setMobileUserMenuOpen(false);
                    }}
                  >
                    <span className={styles.Locale}>{t("give_feedback")}</span>
                  </a>
                </li>
                <li>
                  <a href="#" onClick={() => logout()}>
                    <img alt="Log out" src={exitIcon} style={{ height: "16px", width: "26px" }} />
                    {t("log_out")}
                  </a>
                </li>
              </ul>{" "}
            </li>
          </ul>{" "}
        </div>
      </div>
      <div className={styles.OnlyInMobile}>
        <a
          href="#"
          onClick={() => {
            props.setLanguageSelectionOpen(false);
            props.setMobileUserMenuOpen(true);
          }}
        >
          <img className={styles.UserMenuIcon} alt="Menu" src={userBlue} />
        </a>
      </div>
    </>
  );
};

export default UserMenu;
